
import HeaderRepwise from './HeaderRepwise';
import { get_excercise_id } from '../../../js functions/chartCompute';
import { useEffect, useState } from 'react';
import { get_excercise_category_array } from '../../../js functions/LDBfunctions';

const Headertab = ({ handleLogout, navigateto, user, }) => {

  

    return (
        <div className='headertab-container'>

            <HeaderRepwise handleLogout={handleLogout} navigateto={navigateto} useremail={user?.email} />


           
        </div>
    );
}

export default Headertab
